import { normalize, Schema, arrayOf } from "normalizr";

export const template = new Schema("templates", {
  idAttribute: "uid"
});
export const field = new Schema("fields", {
  idAttribute: "uid"
});
export const page = new Schema("pages", {
  idAttribute: "uid"
});
export const pageTranslation = new Schema("pageTranslations", {
  idAttribute: "slug"
});
export const audit = new Schema("audits", {
  idAttribute: "uid"
});
export const categoryTranslation = new Schema("categoriesTranslations", {
  idAttribute: "uid"
});
export const category = new Schema("categories", {
  idAttribute: "uid"
});
export const fieldCategory = new Schema("fieldCategories", {
  idAttribute: "placeholder"
});
export const fieldCategoryTranslation = new Schema(
  "fieldCategoriesTranslations",
  {
    idAttribute: "uid"
  }
);
export const media = new Schema("media", {
  idAttribute: "uid"
});
export const mediaCategory = new Schema("mediaCategories", {
  idAttribute: "uid"
});
export const menu = new Schema("menus", {
  idAttribute: "placeholder"
});
export const menuItem = new Schema("menuItems", {
  idAttribute: "uid"
});
export const menuTranslation = new Schema("menuTranslations", {
  idAttribute: "uid"
});
export const notification = new Schema("notifications", {
  idAttribute: "uid"
});
export const pagesList = new Schema("pagesLists", {
  idAttribute: "slug"
});
export const setting = new Schema("settingsApi", {
  idAttribute: "uid"
});
export const userGroup = new Schema("userGroups", {
  idAttribute: "uid"
});
export const section = new Schema("sections", {
  idAttribute: "uid"
});
export const gallery = new Schema("galleries", {
  idAttribute: "uid"
});
export const galleryItem = new Schema("galleryItems", {
  idAttribute: "uid"
});
export const order = new Schema("orders", {
  idAttribute: "uid"
});
export const formSubmission = new Schema("formSubmissions", {
  idAttribute: "uid"
});

export function isApiCall(action) {
  if (action.startsWith("GET") || action.startsWith("POST")) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/common/app/schema.js